export const API_CONFIG = {
    BASE_URL: '',
    API_PREFIX: '/api'
};

// UI related settings
export const UI_SETTINGS = {
    OUTSTOCK: {
        DEFAULT_SIMILAR_ITEMS: 7
    }
};

export const AUTH_ENDPOINTS = {
    LOGIN: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/auth/token/`,
    REFRESH_TOKEN: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/auth/token/refresh/`,
    LOGOUT: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/auth/logout/`,
    USER_INFO: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/auth/users/me/`,
};

export const USER_ENDPOINTS = {
    PROFILE: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/users/profile/`,
    // autres endpoints utilisateur
};

export const DATA_ENDPOINTS = {
    // vos autres endpoints
    SOME_DATA: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/data/something/`,
};

// Routes relatives pour axios
export const API_ROUTES = {
    AUTH: {
        LOGIN: '/auth/token/',
        REFRESH_TOKEN: '/auth/token/refresh/',
        LOGOUT: '/auth/logout/',
        USER_INFO: '/auth/users/me/',
    },
    
    DB_MANAGER: {
        BASE: '/db-manager',
        LIST: '/databases/',
        DETAIL: (databaseId: number | string) => `/databases/${databaseId}/`,
        UPLOAD: '/upload/',
        CREATE_EMPTY: '/databases/create-empty/',
        DELETE: (databaseId: number | string) => `/databases/${databaseId}/delete/`,
        GET_ACTIVE: '/databases/active',
        SET_ACTIVE: (name: string) => `/databases/${name}/active/`, // Keep name for now as it might use name lookup
        ARTICLES: (databaseId: number | string) => `/databases/${databaseId}/articles/`,
        ARTICLE_DATA: (databaseId: number | string, articleId: string) => 
            `/databases/${databaseId}/articles/${articleId}/data`,
        FILTERED_ARTICLES: (databaseId: number | string) => `/databases/${databaseId}/articles/filtered/`,
        ARTICLE_FILTERS: (databaseId: number | string) => `/databases/${databaseId}/articles/filters/`,
        ARTICLES_BY_IDS: (databaseId: number | string) => `/databases/${databaseId}/articles/by-ids/`,
        AGGREGATED_SALES: (databaseId: number | string) => `/databases/${databaseId}/aggregated-sales/`,
        UPLOAD_SALES_DATA: (databaseId: number | string) => `/databases/${databaseId}/upload-sales-data/`,
        UPLOAD_ARTICLES_DATA: (databaseId: number | string) => `/databases/${databaseId}/upload-articles-data/`,
        GET_COLUMNS: (databaseId: number | string) => `/databases/${databaseId}/columns/`,
        ARTICLES_COUNT: (databaseId: number | string) => `/databases/${databaseId}/articles/count/`,
        SALES_COUNT: (databaseId: number | string) => `/databases/${databaseId}/sales/count/`,
        SALES_LIST: (databaseId: number | string) => `/databases/${databaseId}/sales/`,
        // CRUD endpoints
        ARTICLE_CRUD: {
            LIST: (databaseId: number | string) => `/databases/${databaseId}/articles/`,
            DETAIL: (databaseId: number | string, articleId: string) => `/databases/${databaseId}/articles/${articleId}/`,
        },
        SALES_CRUD: {
            LIST: (databaseId: number | string) => `/databases/${databaseId}/sales/`,
            DETAIL: (databaseId: number | string, saleId: number | string) => `/databases/${databaseId}/sales/${saleId}/`,
        },
    },

    PREDICTION: {
        BASE: '/prediction',
        AVAILABLE_MODELS: (databaseId: number | string) => `/databases/${databaseId}/available-models/`,
        MODELS: (databaseId: number | string) => `/databases/${databaseId}/available-models/`,
        PREDICTIONS: (databaseId: number | string, articleId: string, modelId: string) => 
            `/databases/${databaseId}/articles/${articleId}/models/${modelId}/predictions`,
        RUN_PREDICTION: (databaseId: number | string) => `/databases/${databaseId}/run-prediction`,
        PREDICTION_DATA: (databaseId: number | string, modelId: string) => 
            `/databases/${databaseId}/models/${modelId}/predictions/data`,
        CORRECTED_DATA: (databaseId: number | string, articleId: string) => 
            `/databases/${databaseId}/articles/${articleId}/corrected-data`,
        ALL_CORRECTED_DATA: (databaseId: number | string) => 
            `/databases/${databaseId}/articles/all/corrected-data`,
        CORRECTED_DATA_FOR_ARTICLE: (databaseId: number | string, articleId: string) => 
            `/databases/${databaseId}/articles/${articleId}/corrected-data`,
        MODEL_STATUS: (databaseId: number | string, algorithm: string) => 
            `/databases/${databaseId}/models/${algorithm}/status/`,
    },
    

    LIFE_CYCLE: {
        BASE: '/life-cycle',
        GET_LIFE_CYCLE: (dbId: string, articleId: string) => 
            `/${dbId}/articles/${articleId}/life-cycle/`,
        SET_LIFE_CYCLE: (dbId: string, articleId: string) => 
            `/${dbId}/articles/${articleId}/set-life-cycle/`,
        GET_LIFE_CYCLES: (dbId: string) => 
            `/${dbId}/articles/life-cycles/`,
        UPLOAD: (dbId: string) => 
            `/${dbId}/upload/`,
        RECOMMENDATIONS: (dbId: string) => `/${dbId}/recommendations/`,
        COUNT: (dbId: string) => `/${dbId}/count/`,
        // CRUD endpoints
        CRUD: {
            LIST: (databaseId: number | string) => `/life-cycle/${databaseId}/`,
            DETAIL: (databaseId: number | string, lifecycleId: number | string) => `/life-cycle/${databaseId}/${lifecycleId}/`,
        },
    },

    PROMOTIONS: {
        BASE: '/promotions',
        LIST: (databaseId: number | string) => `/databases/${databaseId}/promotions/`,
        DETAIL: (databaseId: number | string, id: number) => `/databases/${databaseId}/promotions/${id}/`,
        CREATE: (databaseId: number | string) => `/databases/${databaseId}/promotions/`,
        UPDATE: (databaseId: number | string, id: number) => `/databases/${databaseId}/promotions/${id}/`,
        DELETE: (databaseId: number | string, id: number) => `/databases/${databaseId}/promotions/${id}/`,
        ARTICLE_PROMOTION_PAIRS: (databaseId: number | string) => `/databases/${databaseId}/promotions/article-promotion-pairs/`,
        IMPACTS: {
            LIST: (databaseId: number | string, promotionId: number) => `/databases/${databaseId}/promotions/${promotionId}/impacts/`,
            DETAIL: (databaseId: number | string, promotionId: number, impactId: number) => `/databases/${databaseId}/promotions/${promotionId}/impacts/${impactId}/`,
        },
    },

    STOCK: {
        BASE: '/stock',
        UPLOAD: (dbId: string) => `/${dbId}/upload/`,
        CURRENT: (dbId: string) => `/${dbId}/current/`,
        AT_DATE: (dbId: string) => `/${dbId}/at-date/`,
        LOW_STOCK_ALERTS: (dbId: string) => `/${dbId}/low-stock-alerts/`,
        COVERAGE: (dbId: string) => `/${dbId}/coverage/`,
        MOVING_AVERAGE: (dbId: string) => `/${dbId}/moving-average/`,
        CALCULATED_STOCK: (dbId: string) => `/${dbId}/calculated-stock/`,
        COUNT: (dbId: string) => `/${dbId}/count/`,
        LIST: (dbId: string) => `/${dbId}/list/`,
        // CRUD endpoints
        CRUD: {
            LIST: (databaseId: number | string) => `/stock/${databaseId}/`,
            DETAIL: (databaseId: number | string, stockId: number | string) => `/stock/${databaseId}/${stockId}/`,
        },
    },

    OUTSTOCK: {
        BASE: '/outstock',
        SIMILAR_ITEMS: (dbId: string) => `/${dbId}/similar-items/`,
        DECLARATIONS: (dbId: string) => `/${dbId}/declarations/`,
        DECLARATIONS_LIST: (dbId: string) => `/${dbId}/declarations/list/`,
        DECLARATION_DETAIL: (dbId: string, declarationId: string) => `/${dbId}/declarations/${declarationId}/`,
        DECLARATION_DELETE: (dbId: string, declarationId: string) => `/${dbId}/declarations/${declarationId}/delete/`,
        CORRECTED_VALUES: (dbId: string) => `/${dbId}/corrected-values/`,
        CORRECTIONS: (dbId: string) => `/${dbId}/corrections/`,
    },

    SUPPLIERS: {
        BASE: '/suppliers',
        UPLOAD: (dbId: string) => `/${dbId}/upload/`,
        COUNT: (dbId: string) => `/${dbId}/count/`,
        LIST: (dbId: string) => `/${dbId}/list/`,
        // CRUD endpoints
        CRUD: {
            LIST: (databaseId: number | string) => `/suppliers/${databaseId}/`,
            DETAIL: (databaseId: number | string, supplierId: number | string) => `/suppliers/${databaseId}/${supplierId}/`,
        },
    },

    ARTICLE_SUPPLIERS: {
        BASE: '/article-suppliers',
        UPLOAD: (dbId: string) => `/${dbId}/upload/`,
        COUNT: (dbId: string) => `/${dbId}/count/`,
        LIST: (dbId: string) => `/${dbId}/list/`,
        // CRUD endpoints
        CRUD: {
            LIST: (databaseId: number | string) => `/article-suppliers/${databaseId}/`,
            DETAIL: (databaseId: number | string, articleSupplierId: number | string) => `/article-suppliers/${databaseId}/${articleSupplierId}/`,
        },
    },

    OPTIMIZATION: {
        BASE: '/optimization',
        RUN: (dbId: string) => `/${dbId}/run/`,
        RESULTS: (dbId: string, runId: string) => `/${dbId}/results/${runId}/`,
        LIST: (dbId: string) => `/${dbId}/list/`,
        SET_ORDER_STATUS: (dbId: string, optimizedOrderId: string) => `/${dbId}/orders/${optimizedOrderId}/status/`,
        SET_CONTAINER_STATUS: (dbId: string, containerId: string) => `/${dbId}/containers/${containerId}/status/`,
        SET_RUN_STATUS: (dbId: string, runId: string) => `/${dbId}/runs/${runId}/status/`,
    }
    ,
    APPRO: {
        BASE: '/appro',
        INVENTORY: {
            AGGREGATE: (dbId: string) => `/inventory/${dbId}/aggregate/`,
        },
        ORDERS: {
            COMMIT: (dbId: string) => `/orders/draft/${dbId}/commit/`,
            LIST: (dbId: string) => `/orders/${dbId}/list/`,
            DELETE: (dbId: string, orderId: number | string) => `/orders/${dbId}/order/${orderId}/`,
            STATUS: {
                ORDER: (dbId: string, orderId: number | string) => `/orders/${dbId}/order/${orderId}/status/`,
                CONTAINER: (dbId: string, containerId: number | string) => `/orders/${dbId}/container/${containerId}/status/`,
                LINE: (dbId: string, lineId: number | string) => `/orders/${dbId}/line/${lineId}/status/`,
            }
        }
    },
};

// URLs complètes
export const FULL_URLS = {
    AUTH: {
        LOGIN: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/auth/token/`,
        USER_INFO: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/auth/users/me/`,
    },
    DB_MANAGER: {
        BASE: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/db-manager/`,
    },
    PREDICTION: {
        BASE: `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/prediction/`,
    },
    PROMOTIONS: {
        BASE: (dbName: string) => `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}/databases/${dbName}/promotions/`,
    }
};